<template>
  <router-link :to="`/detail/${nodeData.address}`" class="titem">
      <div class="titem-left">
        <img :src="nodeData.logo" class="titem-logo">
        <div>
          <p class="titem-p1">{{nodeData.name}}</p>
          <!-- <p class="titem-p2"><span>Fee: </span>{{formatPercent(nodeData.fee,2)}}</p> -->
          <p class="titem-p2" :class="{supernodeText : nodeData.isSuperNode,candidateText : !nodeData.isSuperNode}">{{nodeData.isSuperNode?'Supernode':'Candidate'}}</p>
        </div>
      </div>

      <div class="titem-mr">
        <div class="titem-mid">
          <p class="titem-p3">{{formatPercent(nodeData.fee,2)}}</p>
          <p class="titem-p2">Fee</p>
        </div>

        <div class="titem-right" >
          <el-progress :stroke-width="10" :percentage="currentPercent(nodeData.currentCapacity,nodeData.capacity)" :color="currentPercent(nodeData.currentCapacity,nodeData.capacity)==100?'#FFB637':'#49CC8B'"
                   slot="reference" :show-text="false" style="width: 0.8rem"></el-progress>
          <span v-if="currentPercent(nodeData.currentCapacity,nodeData.capacity)<100">Capacity</span>
          <el-popover
            placement="top-end"
            trigger="click"
            v-if="currentPercent(nodeData.currentCapacity,nodeData.capacity)==100"
            >
            <div class="tip-content">The Supernode is full, you will not be able to receive any staking rewards if you lease VSYS to this address.</div>
            <span @click.stop.prevent class="fullTip" slot="reference">Full</span>
          </el-popover>
        </div>
      </div>
    </router-link>
</template>

<script>
  import Capacity from '@/components/table/tablecell/Capacity';
  import { formatCycle, formatPercent } from '@/utils/data_parse';

  export default {
    name: 'NodeItem',
    components: {
      Capacity,
    },
    props: {
      nodeData: Object,
    },
    methods: {
      formatCycle,
      formatPercent,

      currentPercent(current, total) {
        if (current && total) {
          const percent = Math.min(current / total, 1) * 100;
          return percent;
        }
        if (total) {
          return 0;
        }
        return 100;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .titem{
    width: 3.45rem;
    height: 0.72rem;
    background: white;
    box-shadow: 0 2px 0.16rem rgba(#323233,0.08);
    border-radius: 0.06rem;
    display: flex;
    align-items: center;
    padding: 0 0.15rem;
    box-sizing: border-box;
    justify-content: space-between;
    &-left{
      display: flex;
      align-items: center;
    }
    &-logo{
      width: 0.28rem;
      margin-right: 0.1rem;
    }
    &-p1{
      font-size: 0.16rem;
      color: #323233;
      margin-bottom: 0.04rem;
    }
    &-p2{
      font-size: 0.12rem;
      color: #7D7D80;
      span{
        color: #7D7D80;
      }
    }
    &-mr{
      display: flex;
      width: 1.35rem;
      justify-content: space-between;
      align-items: center;
    }
    &-mid{
      // margin-right: 0.2rem;
    }
    &-p3{
      font-size: 0.12rem;
      color: #323233;
      margin-bottom: 0.05rem;
    }
    .supernodeText{
      color: #FFAA70;
    }
    &-right{
      span {
        font-size: 0.12rem;
        color: #7D7D80;
        display: block;
        margin-top: 0.08rem;
      }
    }
    .fullTip{
      font-size: 12px;
      color: #FF8837;
      border: 1px solid #FF8837;
      padding-left: 4px;
      padding-right: 4px;
      height: 15px;
      line-height: 15px;
      border-radius: 3px;
      cursor: pointer;
      width: 21px;
    }
  }
</style>
